import React, { useEffect, useState } from "react";
import { OverviewTabProps } from "@shared/interfaces/ProjectsFiles";
import ProjectForm from "@pages/Project/components/ProjectForm";
import useEmojiPicker from "@pages/Project/utils/useEmojiPicker";
import { FormProvider } from "react-hook-form";

const OverviewTab: React.FC<OverviewTabProps> = ({
  project,
  isEditing,
  methods,
}) => {
  const [geoJson, setGeoJson] = useState<any>(project?.geojson_data || null);
  const firstCountry = project?.countries?.[0];
  const [coordinates, setCoordinates] = useState<[number, number]>([
    48.3794, 31.1656,
  ]);
  const [originalGeoJson, setOriginalGeoJson] = useState<any>(
    project?.geojson_data || null
  );

  const [loading, setLoading] = useState(false);

  const { setValue } = methods;

  const [icon, setIcon] = useState("");

  useEffect(() => {
    setIcon(project.icon ? project.icon : "");
  }, [project]);

  const {
    icon: selectedIcon,
    showEmojiPicker,
    setShowEmojiPicker,
    handleEmojiSelect,
  } = useEmojiPicker(project.icon ?? "", setIcon);

  useEffect(() => {
    setLoading(true);
    const fetchCoordinates = async () => {
      if (!firstCountry?.name) {
        setLoading(false);
        return;
      }
      try {
        const response = await fetch(
          `https://restcountries.com/v3.1/name/${firstCountry.name}`
        );
        const data = await response.json();
        if (data && data[0]?.latlng) {
          setCoordinates(data[0].latlng);
        }
      } catch (error) {
        console.error("Error fetching country coordinates:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCoordinates();
  }, [firstCountry?.name]);

  useEffect(() => {
    setOriginalGeoJson(project?.geojson_data || null);
  }, [project?.geojson_data]);

  const handleGeoJsonUpdate = (updatedGeoJson: any) => {
    setValue("geojson_data", updatedGeoJson);
    setGeoJson(updatedGeoJson);
  };

  return (
    <FormProvider {...methods}>
      <ProjectForm
        loading={loading}
        isEditing={isEditing}
        handleGeoJsonUpdate={handleGeoJsonUpdate}
        showEmojiPicker={showEmojiPicker}
        setShowEmojiPicker={setShowEmojiPicker}
        handleEmojiSelect={(emoji) => {
          setValue("icon", emoji.emoji), handleEmojiSelect(emoji);
        }}
        icon={selectedIcon}
        originalGeoJson={project?.geojson_data || null}
        createForm={false} // Editing mode
      />
    </FormProvider>
  );
};

export default OverviewTab;
